import { connect } from 'react-redux';
import { isEqual } from 'lodash';

// Like connect, but does a deep compare of the mapStateToProps
// return value to allow for arrays, nested objects, etc.
/* eslint-disable max-params */
export const connectDeep = (
  mapStateToProps,
  mapDispatchToProps = null,
  mergeProps = null,
  options = {}
) =>
  connect(mapStateToProps, mapDispatchToProps, mergeProps, {
    areStatePropsEqual: isEqual,
    ...options
  });
/* eslint-disable max-params */
